module.exports = __webpack_public_path__ + "static/media/pdf.6d42506f.png";